export default function textAnimation() {
  textClipAnim();

  // ==================================
  // テキストを徐々に表示
  // ==================================
  function textClipAnim() {
    const images = document.querySelectorAll(".js-textClipAnim");

    const options = {
      root: null,
      rootMargin: "-100px 0px -300px 0px",
      threshold: [0],
    };

    function callback(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-active");
          observer.unobserve(entry.target);
        }
      });
    }

    const observer = new IntersectionObserver(callback, options);

    images.forEach((image) => {
      observer.observe(image);
    });
  }
}
